/* SKINOVA — interacciones (vanilla, sin librerías) */
(function () {
  if (window.__skInit) return;
  window.__skInit = true;

  document.documentElement.classList.add('sk-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveals + secciones que se animan al entrar ---- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('sk-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    root.querySelectorAll('.sk-reveal, [data-sk-observe]').forEach(function (el) {
      if (el.dataset.skObs) return;
      el.dataset.skObs = '1';
      if (io && !reduce) io.observe(el); else el.classList.add('sk-visible');
    });
  }

  /* ---- héroe: zoom-out al cargar ---- */
  function initHero(root) {
    root.querySelectorAll('.sk-hero').forEach(function (el) {
      requestAnimationFrame(function () { el.classList.add('sk-loaded'); });
    });
  }

  /* ---- manifiesto: palabra a palabra con el scroll ---- */
  var manifestos = [];
  function initManifesto(root) {
    root.querySelectorAll('[data-sk-words]').forEach(function (el) {
      if (el.dataset.skInit) return;
      el.dataset.skInit = '1';
      if (reduce) return;
      el.classList.add('sk-words-ready');
      manifestos.push({ el: el, words: el.querySelectorAll('.sk-word') });
    });
  }
  function updateManifestos() {
    var vh = window.innerHeight;
    manifestos.forEach(function (m) {
      if (!m.el.isConnected) return;
      var r = m.el.getBoundingClientRect();
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * m.words.length);
      m.words.forEach(function (w, i) { w.classList.toggle('is-lit', i < n); });
    });
  }

  /* ---- hotspots: punto <-> lista sincronizados ---- */
  function initHotspots(root) {
    root.querySelectorAll('[data-sk-hot]').forEach(function (wrap) {
      if (wrap.dataset.skInit) return;
      wrap.dataset.skInit = '1';
      var points = wrap.querySelectorAll('.sk-hot__point');
      var items = wrap.querySelectorAll('.sk-hot__item');
      function activate(i) {
        points.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
        items.forEach(function (it, j) { it.classList.toggle('is-active', j === i); });
      }
      points.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { activate(i); });
        p.addEventListener('click', function () { activate(i); });
        p.addEventListener('focus', function () { activate(i); });
      });
      items.forEach(function (it, i) { it.addEventListener('mouseenter', function () { activate(i); }); });
      wrap.addEventListener('mouseleave', function () { activate(-1); });
    });
  }

  /* ---- panorámica: parallax suave ---- */
  var panos = [];
  function initPano(root) {
    root.querySelectorAll('[data-sk-parallax]').forEach(function (el) {
      if (el.dataset.skInit) return;
      el.dataset.skInit = '1';
      if (!reduce) panos.push(el);
    });
  }
  function updatePanos() {
    var vh = window.innerHeight;
    panos.forEach(function (el) {
      if (!el.isConnected) return;
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > vh) return;
      var k = parseFloat(el.dataset.skParallax || '0.08');
      var off = (box.top + box.height / 2 - vh / 2) * -k;
      el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });
  }

  /* ---- timeline: la línea se dibuja con el scroll ---- */
  var lines = [];
  function initTimeline(root) {
    root.querySelectorAll('[data-sk-line]').forEach(function (el) {
      if (el.dataset.skInit) return;
      el.dataset.skInit = '1';
      if (!reduce) lines.push(el);
    });
  }
  function updateLines() {
    var vh = window.innerHeight;
    lines.forEach(function (el) {
      if (!el.isConnected) return;
      var r = el.getBoundingClientRect();
      var p = (vh * 0.7 - r.top) / r.height;
      el.style.setProperty('--sk-progress', Math.max(0, Math.min(1, p)).toFixed(3));
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateManifestos(); updatePanos(); updateLines();
      ticking = false;
    });
  }

  /* ---- acordeones (FAQ y página de producto) ---- */
  function initAccordions(root) {
    root.querySelectorAll('.sk-faq__q').forEach(function (btn) {
      if (btn.dataset.skInit) return;
      btn.dataset.skInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.sk-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---- botón magnético ---- */
  function initMagnetic(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    root.querySelectorAll('[data-sk-magnetic]').forEach(function (btn) {
      if (btn.dataset.skInit) return;
      btn.dataset.skInit = '1';
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = 'translate(' + (x * 8).toFixed(1) + 'px,' + (y * 6).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---- página de producto: galería, variantes y cantidad ---- */
  function formatMoney(cents, fmt) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    if (!fmt) return '$' + amount;
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }
  function initProduct(root) {
    root.querySelectorAll('[data-sk-pdp]').forEach(function (pdp) {
      if (pdp.dataset.skInit) return;
      pdp.dataset.skInit = '1';

      var main = pdp.querySelector('.sk-pdp__main img');
      pdp.querySelectorAll('.sk-pdp__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          pdp.querySelectorAll('.sk-pdp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (main) { main.style.opacity = 0; setTimeout(function () { main.src = t.dataset.full; main.style.opacity = 1; }, 180); }
        });
      });

      var qty = pdp.querySelector('.sk-qty input');
      pdp.querySelectorAll('.sk-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value || '1', 10) + parseInt(b.dataset.step, 10);
          qty.value = Math.max(1, v);
          syncBundle();
        });
      });

      // selector de pack: fija la cantidad; el descuento lo aplica Shopify en el checkout
      var bundle = pdp.querySelector('[data-sk-bundle]');
      function syncBundle() {
        if (!bundle || !qty) return;
        var n = parseInt(qty.value || '1', 10);
        bundle.querySelectorAll('input[type="radio"]').forEach(function (r) {
          r.checked = parseInt(r.value, 10) === n;
          r.closest('.sk-bundle__opt').classList.toggle('is-active', r.checked);
        });
      }
      if (bundle && qty) {
        bundle.querySelectorAll('input[type="radio"]').forEach(function (r) {
          r.addEventListener('change', function () { qty.value = r.value; syncBundle(); });
        });
        qty.addEventListener('input', syncBundle);
        syncBundle();
      }

      var dataEl = pdp.querySelector('[data-sk-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var fmt = pdp.dataset.moneyFormat;
      var idInput = pdp.querySelector('input[name="id"]');
      var btn = pdp.querySelector('[data-sk-add]');
      var priceNow = pdp.querySelector('.sk-price__now');
      var priceWas = pdp.querySelector('.sk-price__was');
      function update() {
        var chosen = [];
        pdp.querySelectorAll('[data-sk-option]').forEach(function (group) {
          var c = group.querySelector('input:checked');
          chosen.push(c ? c.value : null);
        });
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!v) return;
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = formatMoney(v.price, fmt);
        if (bundle) {
          var pct = parseInt(bundle.dataset.pct, 10) || 0;
          var free = parseInt(bundle.dataset.free, 10) || 0;
          bundle.querySelectorAll('[data-sk-bprice]').forEach(function (el) {
            var n = parseInt(el.dataset.skBprice, 10);
            var total = free > 0 ? v.price * Math.max(n - free, 1) : (v.price - Math.floor(v.price * pct / 100)) * n;
            el.textContent = formatMoney(n > 1 ? total : v.price, fmt);
          });
          bundle.querySelectorAll('[data-sk-bfull]').forEach(function (el) {
            el.textContent = formatMoney(v.price * parseInt(el.dataset.skBfull, 10), fmt);
          });
        }
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) { priceWas.textContent = formatMoney(v.compare_at_price, fmt); priceWas.hidden = false; }
          else priceWas.hidden = true;
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.querySelector('span').textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        }
        if (v.featured_image && main && pdp.dataset.variantImages !== 'false') main.src = v.featured_image.src;
        var low = pdp.querySelector('[data-sk-low]');
        if (low) {
          var th = parseInt(low.dataset.threshold || '0', 10);
          var show = v.inventory !== null && v.inventory > 0 && v.inventory <= th;
          low.hidden = !show;
          if (show) low.textContent = (low.dataset.text || '').replace('[n]', v.inventory);
        }
      }
      pdp.querySelectorAll('[data-sk-option] input').forEach(function (i) { i.addEventListener('change', update); });
    });
  }

  /* ---- vídeos: solo se reproducen cuando están en pantalla ---- */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.2 }) : null;
  function initVideos(root) {
    root.querySelectorAll('.sk-vid__card video, .sk-pano__media video').forEach(function (v) {
      if (v.dataset.skInit) return;
      v.dataset.skInit = '1';
      v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      /* Shopify añade loading="lazy" + <source>: en algunos navegadores el vídeo no llega a cargar nunca.
         Usamos el MP4 directamente como src. */
      v.removeAttribute('loading');
      var mp4 = v.querySelector('source[type="video/mp4"]') || v.querySelector('source');
      if (mp4 && !v.getAttribute('src')) { v.preload = 'auto'; v.src = mp4.src; v.load(); }
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); v.setAttribute('controls', ''); return; }
      if (vio) vio.observe(v);
    });
  }

  /* ---- carrusel de reseñas (solo reseñas reales añadidas en el editor) ---- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  /* rellena el carrusel con las reseñas reales que pinta Judge.me en la página */
  function fillAutoReviews(wrap) {
    var minStars = parseInt(wrap.dataset.minStars || '4', 10);
    var max = parseInt(wrap.dataset.max || '5', 10);
    var minChars = parseInt(wrap.dataset.minChars || '0', 10);
    var picked = [];
    document.querySelectorAll('.jdgm-rev').forEach(function (r) {
      if (picked.length >= max) return;
      var score = parseInt(r.dataset.score || '0', 10) || r.querySelectorAll('.jdgm-star.jdgm--on').length;
      var bodyEl = r.querySelector('.jdgm-rev__body');
      var body = bodyEl ? bodyEl.innerText.replace(/\s+/g, ' ').trim() : '';
      if (score < minStars || body.length < minChars) return;
      var authorEl = r.querySelector('.jdgm-rev__author');
      var pic = r.querySelector('.jdgm-rev__avatar-image, .jdgm-rev__pics img, .jdgm-rev__pic-img');
      var picSrc = pic ? (pic.getAttribute('data-src') || pic.getAttribute('src') || '') : '';
      picked.push({
        score: score,
        body: body.length > 180 ? body.slice(0, 177).replace(/\s\S*$/, '') + '…' : body,
        author: authorEl ? authorEl.innerText.trim() : '',
        verified: !!r.querySelector('.jdgm-rev__buyer-badge'),
        pic: picSrc
      });
    });
    if (!picked.length) return false;
    var track = wrap.querySelector('.sk-rev__track');
    var dots = wrap.querySelector('.sk-rev__dots');
    var existing = track.querySelectorAll('.sk-rev__item').length;
    picked = picked.slice(0, Math.max(0, max - existing));
    if (!picked.length) return false;
    track.insertAdjacentHTML('beforeend', picked.map(function (p, i) {
      i += existing;
      var stars = '';
      for (var s = 1; s <= 5; s++) stars += s <= p.score ? '★' : '☆';
      var av = p.pic
        ? '<img class="sk-rev__avatar" src="' + esc(p.pic) + '" alt="" width="56" height="56" loading="lazy">'
        : '<span class="sk-rev__avatar sk-rev__initial">' + esc((p.author || '?').charAt(0).toUpperCase()) + '</span>';
      return '<figure class="sk-rev__item' + (i === 0 ? ' is-active' : '') + '">' + av +
        '<div><blockquote>"' + esc(p.body) + '"</blockquote><figcaption>' + esc(p.author) +
        (p.verified ? ' · <em>' + esc(wrap.dataset.verified) + '</em>' : '') +
        ' <span class="sk-stars" aria-label="' + p.score + ' out of 5">' + stars + '</span></figcaption></div></figure>';
    }).join(''));
    var total = track.querySelectorAll('.sk-rev__item').length;
    var html = '';
    for (var d = 0; d < total && total > 1; d++) html += '<button type="button" class="' + (d === 0 ? 'is-active' : '') + '" aria-label="Review ' + (d + 1) + '"></button>';
    dots.innerHTML = html;
    wrap.hidden = false;
    return true;
  }

  function initReviews(root) {
    root.querySelectorAll('[data-sk-rev-auto]').forEach(function (wrap) {
      if (wrap.dataset.skAuto) return;
      wrap.dataset.skAuto = '1';
      var hasManual = wrap.querySelectorAll('.sk-rev__item').length > 0;
      if (fillAutoReviews(wrap)) { setupCarousel(wrap); return; }
      var tries = 0;
      var mo = new MutationObserver(function () {
        if (document.querySelector('.jdgm-rev') && fillAutoReviews(wrap)) { mo.disconnect(); clearInterval(t); setupCarousel(wrap); }
      });
      mo.observe(document.body, { childList: true, subtree: true });
      var t = setInterval(function () {
        tries++;
        if (tries > 12) { clearInterval(t); mo.disconnect(); if (hasManual) setupCarousel(wrap); }
      }, 1000);
    });
    root.querySelectorAll('[data-sk-rev]:not([data-sk-rev-auto])').forEach(setupCarousel);
  }

  function setupCarousel(wrap) {
      if (wrap.dataset.skInit) return;
      wrap.dataset.skInit = '1';
      var items = wrap.querySelectorAll('.sk-rev__item');
      var dots = wrap.querySelectorAll('.sk-rev__dots button');
      if (items.length < 2) return;
      var i = 0, timer;
      function go(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (it, j) { it.classList.toggle('is-active', j === i); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }
      function start() { if (!reduce) timer = setInterval(function () { go(i + 1); }, 6000); }
      dots.forEach(function (d, j) { d.addEventListener('click', function () { clearInterval(timer); go(j); start(); }); });
      wrap.addEventListener('mouseenter', function () { clearInterval(timer); });
      wrap.addEventListener('mouseleave', start);
      start();
  }

  // oferta con cuenta atrás: cuenta hasta data-end y se oculta al terminar
  function initPromo(root) {
    root.querySelectorAll('[data-sk-promo]').forEach(function (el) {
      if (el.dataset.skInit) return;
      el.dataset.skInit = '1';
      var end = Date.parse(el.dataset.end || '');
      if (!end) return;
      var units = {};
      el.querySelectorAll('[data-u]').forEach(function (b) { units[b.dataset.u] = b; });
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (left <= 0) { var sec = el.closest('.shopify-section'); (sec || el).hidden = true; clearInterval(timer); return; }
        if (units.d) units.d.textContent = pad(Math.floor(left / 86400));
        if (units.h) units.h.textContent = pad(Math.floor(left % 86400 / 3600));
        if (units.m) units.m.textContent = pad(Math.floor(left % 3600 / 60));
        if (units.s) units.s.textContent = pad(left % 60);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  function initAll(root) {
    root = root || document;
    initVideos(root);
    initReviews(root);
    initPromo(root);
    initReveals(root); initHero(root); initManifesto(root); initHotspots(root);
    initPano(root); initTimeline(root); initAccordions(root); initMagnetic(root); initProduct(root);
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
